import type {Permissions} from 'auth/PermissionConstants';
import type {UntypedPayload} from 'constants/events/EventPayloadUtils';
import type {FolderSummary} from 'constants/FolderConstants';
import type {BioentityAliasInfo} from 'constants/RegistryConstants';
import type {NavStoreSource} from 'constants/SourceConstants';
import type {FileSummary, Tag} from 'folder-items/FileConstants';

export const FILE_BROWSER_EVENT_PAYLOADS = {
  FILE_BROWSER_MOVE_FILES_COMPLETED: {} as {
    ids: Array<string>;
    folder: FolderSummary | undefined | null;
    permissionsById?: Record<string, Permissions>;
  },
  FILE_BROWSER_MOVE_SHORTCUTS_COMPLETED: {} as {
    ids: Array<string>;
    folder: FolderSummary | undefined | null;
  },
  FILE_BROWSER_RENAME_FILE: {} as {
    id: string;
    name: string;
    displayLabel?: string;
    bioentityAliasInfos?: Array<BioentityAliasInfo>;
  },
  FILE_BROWSER_RENAME_FILE_FAILED: {} as UntypedPayload,
  FILE_BROWSER_ITEMS_DELETED: {} as {
    ids: Array<string>;
  },
  FILE_BROWSER_SOURCE_DELETED: {} as UntypedPayload,
  FILE_BROWSER_SOURCE_UPDATED: {} as UntypedPayload,
  FILE_BROWSER_SOURCES_FETCHED: {} as {sources: Array<NavStoreSource>},
  FILE_BROWSER_RECENTS_FETCHED: {} as {recents: Array<FileSummary>},
  FILE_BROWSER_ADD_TO_WORKSPACE: {} as UntypedPayload,
  FILE_BROWSER_BULK_REMOVE_FROM_WORKSPACE: {} as UntypedPayload,
  FILE_BROWSER_REMOVE_FROM_WORKSPACE: {} as UntypedPayload,
  FILE_BROWSER_MOVE_WORKSPACE_TAB: {} as UntypedPayload,
  FILE_BROWSER_CLEAR_WORKSPACE: {} as UntypedPayload,
  FILE_BROWSER_UNREGISTER_FILES: {} as {
    ids: Array<string>;
    parentFolderIds: Array<string>;
  },
  SOURCES_UPDATED_FROM_GRAPHQL: {} as UntypedPayload,

  FILES_FETCH_COMPLETED: {} as UntypedPayload,
  FOLDER_INVALIDATED: {} as UntypedPayload,

  FILE_AUTHORS_UPDATED: {} as UntypedPayload,
  FILE_TAGS_UPDATE_STARTED: {} as UntypedPayload,
  FILE_TAGS_UPDATED: {} as {
    tagData: Array<{id: string; tags: Array<Tag>}>;
  },
  FILE_TAGS_UPDATE_FAILED: {} as UntypedPayload,
  // TODO(T6458): Get rid of this event
  FILE_TAGS_WITH_FINDER_UPDATED: {} as {
    finderId: string;
    tagData: Array<{id: string; tags: Array<Tag>}>;
  },
  FILE_TAG_SCHEMA_UPDATED: {} as UntypedPayload,

  SOURCE_ADD_AUDITOR_COMPLETED: {} as UntypedPayload,
  SOURCE_REMOVE_AUDITOR_COMPLETED: {} as UntypedPayload,
} as const;

export type FileBrowserEventPayload = typeof FILE_BROWSER_EVENT_PAYLOADS;
